import { keepPreviousData, useQuery } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { CompanyType } from "types/CompanyTypes";
import { MetaType } from "types/UtilsTypes";

export default function useGetCompanies(
  page: number,
  enabled = true,
  origin?: string,
  isAdmin?: boolean
) {
  return useQuery({
    queryKey: ["companies", page, origin],
    queryFn: async () => {
      return axiosInstance
        .get(
          `/companies${isAdmin ? "/admin" : ""}?page=${page}${
            origin ? `&origin=${origin}` : ""
          }`
        )
        .then((res) => res.data);
    },
    placeholderData: keepPreviousData,
    select: (data: { data: CompanyType[]; meta: MetaType }) => data,
    retry: false,
    enabled,
    staleTime: 1000 * 15,
  });
}
